import { Box, Button } from '@chakra-ui/react';
import { Dialog, Portal } from '@halo/ui-react';
import { useTranslation } from 'react-i18next';

export interface JoinDialogProps {
  open: boolean;
  onClose: (open: boolean) => void;
  onOk: () => void;
}

export const JoinDialog = ({ open, onClose, onOk }: JoinDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog.Root
      placement="center"
      open={open}
      onOpenChange={({ open }) => {
        onClose(open);
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content w="auto">
            <Dialog.CloseTrigger />
            <Dialog.Body padding="5">
              <Box fontSize="md">{t('calls.youAreAlreadyInACall')}</Box>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="ghost" color="fg" borderRadius="lg">
                  {t('buttons.cancel')}
                </Button>
              </Dialog.ActionTrigger>
              <Button bg="#00BC00" borderRadius="lg" onClick={onOk}>
                {t('buttons.join')}
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
};
